import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';

import { InvitedByService } from 'src/app/services/setting/invited-by.service';
import { PrivilegeService } from 'src/app/services/account/privilege/privilege.service';
import { ModuleService } from 'src/app/services/account/privilege/module.service';

import { SettingVisitorComponent } from 'src/app/components/setting/setting-visitor/setting-visitor.component';
import { VisitorPageComponent } from 'src/app/components/visitor/visitor-page/visitor-page.component';
import { GuestListComponent } from 'src/app/components/guest/guest-list/guest-list.component';

import { SettingField } from 'src/app/interfaces/database';
import { ModuleType } from 'src/app/types/general';
import { VisitorSettingType } from 'src/app/types/visitor';
import { GuestFilterType, QrcodeType } from 'src/app/types/guest';
import { AccountService } from 'src/app/services/account/account.service';
import { SettingVisitorWizardComponent } from 'src/app/components/setting/setting-visitor-wizard/setting-visitor-wizard.component';
// import { SwiperOptions } from 'swiper';
import { FunctionService } from 'src/app/services/general/function.service';
import { VisitorService } from 'src/app/services/visitor/visitor.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AccountSettingType } from 'src/app/types/account';
import { CurrentPrivilege } from 'src/app/interfaces/privilege';
import { VisitorModeService } from 'src/app/services/visitor/visitor-mode.service';

/**
 * Guest QR code page for display send qr code status.
 */
@Component({
  selector: 'app-guest-qrcode',
  templateUrl: './guest-qrcode.page.html',
  styleUrls: ['./guest-qrcode.page.scss'],
})
export class GuestQrcodePage implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event'])onResize(event: any) {
    this.setupSlidePerView();
  }
  /**
   * Watch screen orientation change for login slider setup
   */
  @HostListener('window:orientationchange', ['$event']) onOrientationChange(event: any) {
    this.setupSlidePerView();
  }

  /**
   * Ion content
   */
  @ViewChild('content', { read: ElementRef }) content: ElementRef;
  // @HostListener('window:resize', ['$event']) onResize(event: any) {
  // }

  ready: boolean;
  /**
   * Module
   */
  module: ModuleType;
  /**
   * Invited by of statistic
   */
  invitedBy: SettingField | string;
  /**
   * Invited by list
   */
  invitedByList: SettingField[];

  slidePerView: number;

  quickSetup: boolean;

  currentPrivilege: CurrentPrivilege;

  newWebsiteMode: boolean;
  visitorMode: boolean;
  
  /**
   * Invited by list subscription
   */
  private invitedBySubscription: Subscription;

  private visitorSubscription: Subscription;

  private privilegeSubscription: Subscription;

  /**
   * Constructor
   * @param modalController modal controller
   * @param moduleService module service
   * @param invitedByService invited by service
   * @param privilegeService privilege service
   * @param popupService popup service
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalController: ModalController,
    private moduleService: ModuleService,
    private invitedByService: InvitedByService,
    private privilegeService: PrivilegeService,
    private accountService: AccountService,
    private visitorService: VisitorService,
    private visitorModeService: VisitorModeService,
  ) { }


  ngOnInit(): void {
    this.watchRoute();
  }

  ngOnDestroy(): void {
    this.unwatch();
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.settingType) {
        this.checkSettingType(state.settingType);
      } else if (param?.settingType) {
        this.checkSettingType(param.settingType);
      }
    });
  }

  /**
   * View before enter
   */
  ionViewWillEnter() {
    this.module = this.moduleService.currentModule;
    this.watch();
    this.ready = true;
    this.invitedBy = '';
  }

  ionViewDidEnter() {
    this.setupSlidePerView();
  }

  /**
   * View before leave
   */
  ionViewWillLeave() {
    this.unwatch();
    this.ready = false;
  }
  
  watch() {
    this.watchInvitedBy();
    this.watchVisitor();
    this.watchPrivilege();
  }

  unwatch() {
    this.unwatchInvitedBy();
    this.unwatchVisitor();
    this.unwatchPrivilege();
  }

  /**
   * Watch invited by list
   */
  async watchInvitedBy() {
    if (!this.invitedBySubscription) {
      this.invitedBySubscription = this.invitedByService.observableInvitedbyList.subscribe((invitedByList: SettingField[]) => {
        this.invitedByList = this.invitedByService.getInvitedByList();
      });
    }
  }

  /**
   * Unwatch invited by list
   */
  async unwatchInvitedBy() {
    if (this.invitedBySubscription) {
      this.invitedBySubscription.unsubscribe();
      this.invitedBySubscription = null;
    }
  }

  async watchVisitor() {
    if (!this.visitorSubscription) {
      this.visitorSubscription = this.visitorService.observablePageData.subscribe((pageData: any) => {
        this.quickSetup = this.getQuickSetupStatus();
        this.newWebsiteMode = this.visitorModeService.checkNewWebsite();
        this.visitorMode = this.visitorModeService.checkMode();
      })
    }
  }

  async unwatchVisitor() {
    if (this.visitorSubscription) {
      this.visitorSubscription.unsubscribe();
      this.visitorSubscription = null;
    }
  }

  async watchPrivilege() {
    if (!this.privilegeSubscription) {
      this.privilegeSubscription = this.privilegeService.observableCurrentPrivilege.subscribe(() => {
        this.setupPrivilege();
      })
    }
  }

  async unwatchPrivilege() {
    if (this.privilegeSubscription) {
      this.privilegeSubscription.unsubscribe();
      this.privilegeSubscription = null;
    }
  }

  setupPrivilege() {
    if (!this.currentPrivilege) {
      this.currentPrivilege = {};
    }
    if (this.module) {
      this.currentPrivilege = {
        [this.module]: {
          'qrcode': this.checkPrivilege(this.module, 'qrcode'),
        }
      };
    }
    
  }

  setupSlidePerView() {
    if (this.content?.nativeElement?.offsetWidth) {
      this.slidePerView = this.getSlidesPerView();
    } else {
      setTimeout(() => {
        this.setupSlidePerView();
      }, 500);
    }
  }

  getSlidesPerView() {
    const itemWidth = 90;
    const maxSlides = 4;
    let slidesPerView = 4;

    let cardWidth = this.content?.nativeElement?.offsetWidth ? this.content.nativeElement.offsetWidth : window?.innerWidth;
    cardWidth = cardWidth - 22 - (itemWidth / 2);

    slidesPerView = Math.floor(cardWidth / itemWidth);
    if (!slidesPerView || slidesPerView < 1) {
      slidesPerView = 1;
    }
    if (slidesPerView >= maxSlides) {
      slidesPerView = maxSlides;
    } else {
      slidesPerView = slidesPerView + 0.5;
    }
    return slidesPerView;
  }

  checkSettingType(settingType: AccountSettingType) {
    if (settingType === 'guest_page_quick_setup') {
      this.presentVisitorSettingWizard();
    } else if (settingType === 'guest_page_info') {
      this.presentVisitorSettingModal('info');
    } else if (settingType === 'guest_page_setting') {
      this.presentVisitorSettingModal('setting');
    } else if (settingType === 'guest_page_theme') {
      this.presentVisitorSettingModal('theme');
    }
  }

  /**
   * Present visitor setting modal
   */
   async presentVisitorSettingModal(type?: VisitorSettingType) {
    const modal = await this.modalController.create({
      component: SettingVisitorComponent,
      cssClass: 'modal-full-screen-bk',
      componentProps: {
        type
      }
    });
    modal.present();
  }

  async presentVisitorSettingWizard() {
    const modal = await this.modalController.create({
      component: SettingVisitorWizardComponent,
      cssClass: 'modal-full-screen-bk',
      componentProps: {
      }
    });
    modal.present();
  }

  /**
   * Present visitor page modal
   * @param previewData Preview data
   */
  async presentVisitorPageModal() {
    const modal = await this.modalController.create({
      component: VisitorPageComponent,
      cssClass: 'modal-full-screen',
      componentProps: {
        preview: true,
        accountId: this.accountService.accountId,
      }
    });
    modal.present();
  }

  /**
   * Present guest list modal
   * @param invitedBy invited by
   * @param category category
   * @param dietaryReq dietary request
   * @param specialReq special request
   * @param groupType group type
   */
  async presentGuestListModal(qrcode?: QrcodeType) {
    const type: GuestFilterType = {
      qrcode
    };
    const modal = await this.modalController.create({
      component: GuestListComponent,
      cssClass: '',
      componentProps: {
        type,
        mode: 'list'
      }
    });
    modal.present();
  }

  /**
   * Check user privilege
   * @param action Action
   */
  checkPrivilege(module: ModuleType, action: string): boolean {
    return this.privilegeService.checkCurrentUserPrivilege(module, action);
  }

  getQuickSetupStatus(): boolean {
    return this.visitorService.getQuickSetupStatus();
  }

}
